import moment from "moment";
import config from "lib/config";

const DATE_FORMAT =
  config && config.shortDateFormat && config.shortDateFormat.toUpperCase();

const reminder_template = {
  checklistItemId: 0,
  id: 1,
  subject: "",
  reminderDate: moment().add(6, "weeks").format(DATE_FORMAT),
  relativeReminder: "15|b|s",
  reminderType: 0,
  emailAddresses: "",
  receivers: [],
};

export default reminder_template;
